import React,{useState,useEffect} from 'react'
import { fetchEmployees ,addNewEmployee, deleteEmployee} from '../../../redux/action'
import {useSelector,useDispatch} from 'react-redux'
import { encodePhoneNumber } from '../../../helpers/Utils'
import sliderCloseIcon from '../../../assets/images/slider-close-icon.svg'
import {Row, Input, Label, Button, FormGroup } from "reactstrap";
import {Colxx} from '../../../components/shared/CustomBootstrap'

export default function Employees() {
  const dispatch=useDispatch()
  const settings=useSelector(state=>state.settings)
  const authUser=useSelector((state)=>state.authUser)
  const [isAdmin,setIsAdmin]=useState(3)
  const [isVisible,setIsVisible]=useState(false)
  const [num,setNum]=useState({})
  const [newEmployee,setNewEmployee]=useState({
        id:false,
        first_name: "",
        last_name: "",
        is_active: 1,
        is_admin: 0,
        phone_no: "",
        email: "",
        role: false
  })

  const setExistingEmployee=(contact)=>{
        setNewEmployee({
            id:contact.id,
            first_name:contact.first_name,
            last_name:contact.last_name,
            is_active:contact.is_active,
            is_admin:contact.is_admin,
            phone_no:contact.phone_no,
            email:contact.email,
            role:contact.role
        })
  }

  const getEmployees=()=>{
     dispatch(fetchEmployees())
  }

  const setAdmin=()=>{
    let currentAccount=authUser.user.accounts.find((account)=>account.id==authUser.activeAccount);
    if(currentAccount.pivot.user_id==authUser.user.id && currentAccount.pivot.role==1)
    setIsAdmin(1)
    else if(currentAccount.pivot.user_id==authUser.user.id && currentAccount.pivot.role==2){
        setIsAdmin(2)
    }
    else{
        setIsAdmin(3)
    }
  }

  useEffect(()=>{
   getEmployees()
   setAdmin();
  },[])


  const updateTextInput=( target )=>{
    //alert(target.name+" "+target.value)
    let current = newEmployee ;
    if( target.type == "checkbox" ){
      newEmployee[ target.name ] = (newEmployee[ target.name ] == 0 ? 1:0)
    }else{
      newEmployee[ target.name ] = target.value
    } 

    setNewEmployee({...newEmployee})
  }

  const handleSubmit=()=>{
   if( !newEmployee.first_name || !newEmployee.first_name.trim() || !newEmployee.last_name || !newEmployee.last_name.trim() ){
     alert('First name and last name are required.')
     return
   }
   dispatch(addNewEmployee(newEmployee))
    setNewEmployee({first_name: "",
    last_name: "",
    is_active: 1,
    is_admin: 0,
    phone_no: "",
    email: "",
    role: false})
  }

  const canDeleteEmployee=()=>{
    return newEmployee.id && ((isAdmin==1 && (newEmployee.role==2 || newEmployee.role==3)) || (isAdmin==2 && newEmployee.role==3))
  }

  const handleDelete=()=>{
    if( !canDeleteEmployee() ) return
    if( !window.confirm('Permanently remove this employee from your team? This cannot be undone here - they would need to be re-added from scratch. (To temporarily block their access instead, edit them and uncheck "Is Active".)') ) return
    dispatch(deleteEmployee(newEmployee.id))
    setNewEmployee({first_name: "",
    last_name: "",
    is_active: 1,
    is_admin: 0,
    phone_no: "",
    email: "",
    role: false})
  }


    

    return (
    <>
     <div className="row mt-4">
    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 main-section-scroll-height">

    <div className="row pt-1">
                    <div className="col-md-6 col-lg-6 col-sm-12 co-xs-12">
                    </div>
                    <div className="col-md-6 col-lg-6 col-sm-12 co-xs-12">
                        <div className="d-flex justify-content-end align-items-center">
                            <button className="secondary-btn" type="button" data-bs-toggle="offcanvas"
                                data-bs-target="#createContactCanvas" aria-controls="createContactCanvas">
                                Add New
                            </button>
                        </div>
                    </div>
                </div>  



    <table class="mt-2 table table-borderless">
    <thead>
        <tr>
         {/*   <th className="align-middle" style={{width:'12%'}} scope="col">ID</th> */}
            <th className="align-middle" style={{width:'30%'}} scope="col">Name</th>
            <th className="align-middle" style={{width:'14%'}} scope="col">Phone Number</th>
            <th className="align-middle" style={{width:'20%'}} scope="col">Email Address</th>
          {/*  <th className="align-middle" style={{width:'16%'}} scope="col">Address</th>*/}
            <th className="align-middle" style={{width:'17%'}} scope="col">Account Type</th>
            <th className="align-middle" style={{width:'17%'}} scope="col">Employement Status</th>

        </tr>
    </thead>
    <tbody>
      
     {settings && settings.employees_data && settings.employees_data.map((contact)=>(
        
         <tr key={contact.id} data-bs-target={`${((isAdmin==1 && (contact.role==2 || contact.role==3)) || (isAdmin==2 && contact.role==3)) ? '#createContactCanvas':""}`} data-bs-toggle={`${((isAdmin==1 && (contact.role==2 || contact.role==3)) || (isAdmin==2 && contact.role==3)) ? "offcanvas" : ""}`} style={{cursor:"pointer"}} onClick={()=>!((isAdmin==1 && (contact.role==2 || contact.role==3)) || (isAdmin==2 && contact.role==3)) ? alert('Please contact support to modify account owner') : setExistingEmployee(contact)}>
         {/*<td className="align-middle">
             <img width="32" height="32" className="img-fluid me-1" src={userIcon}/> {contact.id}</td>*/}
         <td className="align-middle">{contact.full_name}</td>
         <td className="align-middle">{encodePhoneNumber(contact.phone_no)}</td>
         <td className="align-middle">{contact.email}</td>
         <td className="align-middle">
           
            {contact.role>=3?<div className="tag me-1">Limited</div>:(contact.role==2?<div className="inactive me-1" >Admin</div>:<div className='account_owner me-1'>Super Admin</div>)}
         </td>
         <td className="align-middle">
            {contact.is_active?<div className="tag me-1">Active</div>:<div className="inactive me-1">Inactive</div>}
         </td>
        
         </tr>
        
        ))
        }
        </tbody>
    </table>

    </div>
    </div>



    <div className="offcanvas offcanvas-end" tabIndex="-1" id="createContactCanvas" aria-labelledby="createContactCanvasLabel">
        <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="createContactCanvasLabel">Add Employee</h5>
            <button type="button" className="slider-close-btn" data-bs-dismiss="offcanvas">
                <img src={sliderCloseIcon} className="img-fluid"/>
            </button>
        </div>
        <div className="offcanvas-body">
        <FormGroup row>
            <Colxx style={{marginLeft:"13px",maxWidth:"10%"}} >
                    <FormGroup >
                        <Input 
                            type="checkbox"
                            name = "is_active"
                            checked={newEmployee.is_active}
                            onChange = {e => { updateTextInput(e.target) }}
                        />
                    </FormGroup>
                </Colxx>
                <Colxx>
                    <Label  className="pt-0">Is Active
                    </Label>
                </Colxx>
                
            </FormGroup>


            <FormGroup row>
            <Colxx style={{marginLeft:"13px",maxWidth:"10%"}} >
                    <FormGroup >
                        <Input 
                            type="checkbox"
                            name = "is_admin"
                            checked={newEmployee.is_admin}
                            onChange = {e => { updateTextInput(e.target) }}
                        />
                    </FormGroup>
                </Colxx>
                <Colxx>
                    <Label  className="pt-0">Administrator
                    </Label>
                </Colxx>
                
            </FormGroup>


        <div  className="tags mb-3">
                <input required style={{marginBottom:"30px"}} onChange={e => { updateTextInput(e.target) }} value={newEmployee.first_name} type="text"  name="first_name"   className="form-control slider-inputs" placeholder="First name"/>
            </div>
            <div  className="tags mb-3">
                <input required style={{marginBottom:"30px"}} onChange={e => { updateTextInput(e.target) }} value={newEmployee.last_name} type="text"  name="last_name"   className="form-control slider-inputs" placeholder="Last name"/>
            </div>
            <div  className="tags mb-3">
                <input style={{marginBottom:"30px"}} onChange={e => { updateTextInput(e.target) }} value={newEmployee.phone_no} type="text"  name="phone_no"   className="form-control slider-inputs" placeholder="Phone number"/>
            </div>
            <div  className="tags mb-3">
                <input style={{marginBottom:"30px"}} onChange={e => { updateTextInput(e.target) }} value={newEmployee.email} type="text"  name="email"   className="form-control slider-inputs" placeholder="Email address" disabled={!!newEmployee.id} title={newEmployee.id ? "Email can't be changed after an employee is added" : ""}/>
            </div>
            

            <div className="d-flex justify-content-between mt-4">
                {canDeleteEmployee() ?
                    <button className="slider-cancel-btn" data-bs-dismiss="offcanvas" onClick={handleDelete}>Remove</button>
                    : <span></span>
                }
                <div className="d-flex">
                    <button className="slider-cancel-btn me-2" data-bs-dismiss="offcanvas" >Cancel</button>
                    <button className="slider-success-btn" data-bs-dismiss="offcanvas" onClick={handleSubmit}>{newEmployee.id?'Update':'Add'}</button>
                </div>
            </div>
        </div>
    </div>
    </>
  )
}


